@if (vm$ | async; as vm) {
  <nav mat-tab-nav-bar class="uw-tab-nav-bar uw-tab-nav-bar--sub" [tabPanel]="tabPanel">
    @for (targetType of vm.targetTypes; track targetType) {
      <a
        mat-tab-link
        [active]="vm.selectedTargetType.name == targetType.name"
        (click)="onSelectTargetType(targetType)"
        >
        {{ "profile." + targetType.value | translate }}
      </a>
    }
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
  <p>{{ "profile.suggested_amount_description_1" | translate }}</p>
  @if (vm.selectedTargetType.value !== 'A') {
    <p>{{ "common.note" | translate }}:</p>
  }
  @if (vm.selectedTargetType.value !== 'A') {
    <p>{{ "profile.donation_history" | translate }}</p>
  }
  @if (vm.selectedTargetType.value !== 'A') {
    <p>{{ "profile.donation_history_description" | translate }}</p>
  }
  <p>{{ "common.example" | translate }}:</p>
  @if (vm.selectedTargetType.value !== 'A') {
    <p>{{ "profile.suggested_amount_example_1" | translate }}</p>
  }
  @if (vm.selectedTargetType.value === 'A') {
    <p>{{ "profile.suggested_amount_example_2" | translate }}</p>
  }
  <h4>{{ "profile.current_suggested_giving_amounts" | translate }}:</h4>
  <uw-suggested-amount-list [suggestedAmounts]="vm.suggestedAmounts" (edit)="onEdit($event)" (delete)="onDelete($event)"></uw-suggested-amount-list>
  <button class="uw-default-button" (click)="onAddGivingAmount()">{{ "profile.add_giving_amount" | translate }}</button>
}
